import { PipeTransform, Pipe, Inject, LOCALE_ID } from '@angular/core';
import { DecimalPipe, PercentPipe } from '@angular/common';
@Pipe({ name: 'intPercent' })
export class IntPercentPipe implements PipeTransform {
  constructor( @Inject(LOCALE_ID) private locale: string) { this._percent = new PercentPipe(locale); }
  private _percent: PercentPipe;
  transform(value: any, digits?: string): string {
    if (value === undefined) return undefined;
    return this._percent.transform(value / 100, digits);
  }
}


// WEBPACK FOOTER //
// F:/Agent/vsts-agent1/_work/76/s/CIA.ClientSide/~/@wtw/toolkit/src/pipes/int-percent.pipe.ts